// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"dee7e321","757":"68b713d0","804":"b1f74841"}[chunkId] + ".chunk.css";
};